import React from "react";
import Logo from "../assets/LOGO MEDIA - Black.png";

const Construction = () => {
  return (
    <section className="temp">
      <div  className="temp__dad">
        <div>
          <img src={Logo} alt="logo" />
        </div>
        <h3>Under development</h3>
        <h4>Wait for us soon with a new look</h4>
      </div>
    </section>
  );
};

export default Construction;
